import i18next from 'i18next';
import { Brand } from '@hbo/ui-servicing-react-components';
import { v4 as uuidv4 } from 'uuid';
import client from './client';

export namespace AuthenticationService {
  export enum CustomStatusCode {
    InvalidDetails = 4001,
    AccountLocked = 4023,
    MobileNumberNotPresent = 4101,
    HygieneCheckFailed = 4102
  }

  export interface Payload {
    accountNumber: string;
    postcode: string;
    surname: string;
    dob: string;
  }

  export interface Response {
    clientId: string;
    sourceBank: string;
    mobileNumber: string;
    customStatusCode?: number;
    remainingAttempts?: number;
  }

  export type IssuePayload = string;

  export interface IssueResponse {
    access_token: string;
    token_type: string;
    expires_in: string;
    scope: string;
  }

  export interface RenewPayload {
    client_id: string;
    access_token: string;
  }

  export type RenewResponse = IssueResponse;

  export const authenticate = async (payload: Payload) => {
    try {
      const { data } = await client<Response>({
        method: 'POST',
        url: `${process.env.REACT_APP_4QV_API_PATH}/authenticate`,
        data: payload,
        headers: {
          'X-Journey': 'cst',
          'X-Channel': 'organic'
        }
      });

      if (data.customStatusCode === CustomStatusCode.InvalidDetails) {
        if (data.remainingAttempts <= 2) {
          throw new Error(
            i18next.t('4qv.error.invalidDetailsRemainingAttempts', {
              count: data.remainingAttempts
            })
          );
        } else {
          throw new Error(i18next.t('4qv.error.invalidDetails'));
        }
      }

      return data;
    } catch (error) {
      // @ts-expect-error
      if (error?.response?.status === 404) {
        throw new Error(i18next.t('4qv.error.invalidDetails'));
      }

      throw error;
    }
  };

  export const getIAMToken = async (token: IssuePayload) => {
    const clientId = {
      [Brand.NatWest]: process.env.REACT_APP_IAM_CLIENT_ID_NATWEST,
      [Brand.RoyalBankOfScotland]: process.env.REACT_APP_IAM_CLIENT_ID_RBS
    }[window.obm.brand as unknown as Brand];

    const baseURL = {
      [Brand.NatWest]: process.env.REACT_APP_IAM_API_BASE_URL_NATWEST,
      [Brand.RoyalBankOfScotland]: process.env.REACT_APP_IAM_API_BASE_URL_RBS
    }[window.obm.brand as unknown as Brand];

    const { data } = await client<IssueResponse>({
      method: 'POST',
      baseURL,
      url: `${process.env.REACT_APP_IAM_API_PATH}/${window.obm.brand}/sm/issue`,
      withCredentials: true,
      data: {
        token,
        tokenType: 'JWT',
        client_id: clientId,
        scope: ['a4ir203:mortgages-v1:case-tracking'],
        redirect_uri: 'urn:ietf:wg:oauth:2.0:auto:oo',
        nonce: uuidv4(),
        state: uuidv4()
      }
    });

    return data;
  };
}
